<template>
  <div class="chartContainer">
    <canvas ref="chart"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
export default {
  props: ["capital"],

  mounted() {
    var ctx = this.$refs.chart.getContext("2d"),
      gradient = ctx.createLinearGradient(0, 0, 0, 400);

    gradient.addColorStop(0, "#9561E2");
    // gradient.addColorStop(0.5, "rgba(99, 91, 255, 0.2)");
    gradient.addColorStop(1, "white");

    var labels = [];
    var prices = [];
    this.capital.forEach(value => {
      labels.push(value.date.substring(0, 4));
      prices.push(value.value);
    });

    var tailletab = labels.length;

    if (tailletab > 365) {
      for (var i = 0; i < tailletab; i++) {
        var modulo = i % 365;
        if (modulo != 0) {
        }
        //labels[i]='';
      }
    } else if (tailletab > 30) {
      for (var i = 0; i < tailletab; i++) {
        var modulo = i % 30;
        if (modulo != 0) labels[i] = "";
      }
    } else if (tailletab > 10) {
      for (var i = 0; i < tailletab; i++) {
        var modulo = i % 3;
        if (modulo != 0) labels[i] = "";
      }
    }

    var graphTab = [];
    var graphTabIndex = 0;

    var capitalGraph = {
      label: "Votre solde",
      backgroundColor: gradient,
      pointBackgroundColor: "#9561E2",
      data: prices,
      fill: true,
      cubicInterpolationMode: "monotone",
      pointRadius: 0,
      borderColor: "#9561E2",
      borderWidth: 2
    };

    var tailleCapitalTab = prices.length;
    var capitalSomme = 0;
    for (var i = 0; i < tailleCapitalTab; i++) {
      capitalSomme = capitalSomme + prices[i];
    }
    if (capitalSomme != 0) {
      graphTab[graphTabIndex] = capitalGraph;
      graphTabIndex++;
    }

    var myChart = new Chart(ctx, {
      type: "line",
      data: {
        labels: labels,
        datasets: graphTab
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        maintainAspectRatio: true,
        animation: {
          easing: "easeInOutQuad",
          duration: 2000
        },
        scales: {
          x: {
            grid: {
              display: false
            },
            ticks: {
              color: "#9561E2"
            }
          },
          y: {
            grid: {
              display: false
            },
            ticks: {
              color: "#9561E2",
              callback: function(item) {
                return item + " €";
              }
            }
          }
          // y: [
          //   {
          //     gridLines: {
          //       display: false
          //     },

          //     ticks: {
          //       userCallback: function(value, index, values) {
          //         value = value.toString();
          //         value = value.split(/(?=(?:...)*$)/);
          //         value = value.join(" ");
          //         return value + " " + "€";
          //       },
          //       // Include a euro sign in the ticks
          //       callback: function(value, index, values) {
          //         return value + " " + "€";
          //       },
          //       padding: 10,
          //       fontFamily: "Lato",
          //       fontColor: "rgb(200,200,200)",
          //       suggestedMin: Math.min(...prices) - Math.min(...prices) * 0.2, // minimum will be 0, unless there is a lower value.
          //       // OR //
          //       beginAtZero: false, // minimum value will be 0.
          //       fontStyle: "bold",
          //       fontSize: 12,
          //       autoSkip: true,
          //       maxTicksLimit: 12
          //     }
          //   }
          // ]
        },
        elements: {
          line: {
            tension: 1
          }
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            font: {
              size: 16
            },
            fontFamily: "Lato",
            boxWidth: 15,
            padding: 30
          }
        },
        point: {
          backgroundColor: "white"
        },
        tooltips: {
          titleFontFamily: "Lato",
          titleFontStyle: "normal",
          titleMarginBottom: 10,
          titleAlign: "center",
          backgroundColor: "rgba(38, 42, 62, .95)",
          titleFontColor: "#FFF",
          caretSize: 2,
          cornerRadius: 4,
          xPadding: 20,
          yPadding: 20,
          bodyAlign: "center",
          bodyFontFamily: "Lato",
          bodyFontSize: 14,
          bodyFontStyle: "bold",
          bodyFontColor: "white",
          bodySpacing: 4,
          custom: function(tooltip) {
            if (!tooltip) return;
            // disable displaying the color box;
            tooltip.displayColors = false;
          },
          callbacks: {
            label: function(tooltipItem, data) {
              return (
                "Solde" +
                " : " +
                Math.round(
                  tooltipItem.yLabel
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                ) +
                " " +
                "€"
              );
            }
          }
        }
      }
    });
  }
};
</script>
<style lang="scss">
@import "../../../../../../../resources/sass/_variables.scss";

.chartContainer {
  max-height: 100%;
  max-width: 100%;
  background: $bg_color;
  border-radius: 30px;
  padding: 15px;
}
</style>